import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

//is user is logged in
export const isUserAuthenticated = () => {
  const user = sessionStorage.getItem("authUser");
  if(user) return true;
  return false;
};
// Parts
export const getParts = (request) => api.create(url.GET_PARTS, request);
export const getPart = partId => api.get(url.GET_PART + '/' + partId);
export const addPart = part => api.createForm(url.ADD_PART, part);
export const updatePart = part => api.update(url.UPDATE_PART, part);
export const addPartImages = partImages => api.createForm(url.ADD_PART_IMAGES, partImages);

export const addNewPartImages = (partId, files) => {
  const fd = new FormData();
  files.forEach(f => fd.append("files", f));
  return api.createForm(url.ADD_NEW_PART_IMAGES(partId), fd);
};

export const featurePartImage = (partId, imageId) =>
  api.put(url.PART_IMAGE_FEATURE(partId, imageId));

export const deletePartImage = (partId, imageId) =>
  api.deleteCustom(url.PART_IMAGE(partId, imageId));

// Login Method
export const login = data => api.create(url.LOGIN, data);

export const getFinances = () => api.get(url.GET_FINANCES);
export const getTodayFinances = () => api.get(url.GET_TODAY_FINANCES);
export const getGeneralFinances = () => api.get(url.GET_GENERAL_FINANCES);

// Finance Reports
export const getDailyReport = (startDate, endDate) => {
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  return api.get(`${url.GET_DAILY_REPORT}${params.toString() ? '?' + params.toString() : ''}`);
};

export const getWeeklyReport = (startDate, endDate) => {
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  return api.get(`${url.GET_WEEKLY_REPORT}${params.toString() ? '?' + params.toString() : ''}`);
};

export const getMonthlyReport = (startDate, endDate) => {
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  return api.get(`${url.GET_MONTHLY_REPORT}${params.toString() ? '?' + params.toString() : ''}`);
};

export const getYearlyReport = (startDate, endDate) => {
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  return api.get(`${url.GET_YEARLY_REPORT}${params.toString() ? '?' + params.toString() : ''}`);
};

export const getSalesDetails = (startDate, endDate) => {
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  return api.get(`${url.GET_SALES_DETAILS}${params.toString() ? '?' + params.toString() : ''}`);
};


export const publishPart = partId => api.create(url.PUBLISH_PART+"?partId="+partId, partId);
export const publishVehicle = vehicleId => api.create(url.PUBLISH_VEHICLE+"?vehicleId="+vehicleId, vehicleId);

export const publish = (request) => api.create(url.PUBLISH, request);

// Vehicles
export const getRows = (request) => api.create(url.GET_ROWS, request);
export const getVehicles = (request) => api.create(url.GET_VEHICLES, request);
export const getVehicle = vehicleId => api.get(url.GET_VEHICLE + '/' + vehicleId);
export const addVehicle = vehicle => api.createForm(url.ADD_VEHICLE, vehicle);
export const updateVehicle = vehicle => api.update(url.UPDATE_VEHICLE, vehicle);
export const addVehicleImages = vehicleImages => api.createForm(url.ADD_VEHICLE_IMAGES, vehicleImages);
//export const publishVehicle = vehicleId => api.create(url.PUBLISH_VEHICLE+"?vehicleId="+vehicleId, vehicleId);

// Notes
export const getNotes = (request) => api.create(url.GET_NOTES, request);
export const addNote = note => api.create(url.ADD_NOTE, note);
export const updateNote = note => api.update(url.UPDATE_NOTE, note);
export const addDelivery = (deliveryData, parentId) => {
    const endpoint = parentId ? `${url.ADD_DELIVERY}?parentId=${parentId}` : url.ADD_DELIVERY;
    return api.create(endpoint, deliveryData);
};
export const getDelivery = noteId => api.get(url.GET_DELIVERY(noteId));
export const updateDelivery = (noteId, deliveryData) => api.update(url.UPDATE_DELIVERY(noteId), deliveryData);